// Distintivi.tsx — v037: «fatti conoscere, diventa famoso». Quante persone hai portato su Laughdown (dal tuo link, dalle
// sfide, dai tuoi video) e i distintivi che hai preso: Primo amico (1), Virale (5), Famoso (20), Leggenda (50).
// Sotto, quanto manca al prossimo. Lo mostrano il profilo e lo Store.
import { useTranslation } from "react-i18next";

export const SOGLIE_DISTINTIVI = [
  { n: 1, chiave: "primo", icona: "🌱" },
  { n: 5, chiave: "virale", icona: "🔥" },
  { n: 20, chiave: "famoso", icona: "⭐" },
  { n: 50, chiave: "leggenda", icona: "👑" },
] as const;

export function prossimoDistintivo(portati: number): { n: number; chiave: string; icona: string; mancano: number } | null {
  const s = SOGLIE_DISTINTIVI.find((x) => portati < x.n);
  return s ? { ...s, mancano: s.n - portati } : null;
}

export function Distintivi({ portati, amico }: { portati: number; /** stelle per ogni amico portato */ amico?: number }) {
  const { t } = useTranslation();
  const prossimo = prossimoDistintivo(portati);
  return (
    <div className="ld-distintivi">
      <p className="ld-distintivi-conto">
        <span>{t("distintivi.portati")}</span> <strong>{portati}</strong>
      </p>
      <ul className="ld-distintivi-elenco" aria-label={t("distintivi.titolo")}>
        {SOGLIE_DISTINTIVI.map((d) => (
          <li key={d.chiave} data-preso={portati >= d.n} title={t(`distintivi.${d.chiave}`)}>
            <span className="ld-distintivo-icona" aria-hidden="true">
              {d.icona}
            </span>
            <span className="ld-distintivo-nome">{t(`distintivi.${d.chiave}`)}</span>
            <span className="ld-distintivo-n">{d.n}</span>
          </li>
        ))}
      </ul>
      {prossimo && (
        <p className="nota-centrata">
          {t("distintivi.prossimo", { n: prossimo.mancano, nome: t(`distintivi.${prossimo.chiave}`) })}
          {amico ? ` ${t("distintivi.stelle", { n: amico })}` : ""}
        </p>
      )}
    </div>
  );
}
